import { Agents } from './Agents';
import { ClientSource } from './ClientSource';
import * as CRM from './CRM';
import { Icp } from './Icp';
import { Mcp } from './Mcp';
import { Notifications } from './Notifications';

export const Constants = {
  Notifications,
  Agents,
  CRM,
  Icp,
  Mcp,
  ClientSource,
};
